// vite-express servíruje SPA i API ze stejného Express serveru → API je VŽDY na stejném
// originu jako stránka (dev :3001, LAN/VPN :80 http, veřejná https). Použití originu stránky
// automaticky zvolí správný protokol+host+port ve všech 4 síťových vrstvách:
//  - odpadá hádání schématu/portu i zapečený VITE_API_PORT (ten v build-fázi CI chybí),
//  - žádný mixed-content (vše dědí schéma stránky),
//  - žádný CORS (vše same-origin); socket.io přes io(origin) zvolí ws/wss dle schématu.
export const API_URL = window.location.origin;
